import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priority'
})
export class PriorityPipe implements PipeTransform {
  transform(value: number): string {

    if (value === 3) {
      return 'Prioridad Baja';
    } else if (value === 2) {
      return 'Prioridad Media';
    } else if (value === 1) {
      return 'Prioridad Alta';
    }else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/priority.ts